export enum UIActionIcon {
  Profile = 'profile',
  Settings = 'settings',
}

export enum UIMenuMode {
  BurgerMenu = 'burgerMenu',
  BackArrow = 'backArrow',
  Empty = 'empty',
}

export enum TopNavigationContentMode {
  Title = 'title',
  Search = 'search',
  Profile = 'profile',
}

export enum TopNavigationLeftAction {
  Menu = 'menu',
  Back = 'back',
  Empty = 'empty',
}

/**
 * The profile to be shown in the top navigation bar.
 */
export interface TopNavigationProfile {
  /** The user ID. */
  userId: string;

  /**
   * The profile ID of the user.
   */
  profileId: string;

  /**
   * The display name of the user.
   */
  profileDisplayName: string;

  /**
   * The avatarUrl URL of the user.
   */
  avatarUri: string;

  /**
   * The online status of the user.
   */
  onlineStatus: boolean;
}

export interface UIMessagingState {
  /** The current page title */
  pageTitle: string;

  /**
   * Whether the current page is a "nested" page, ie. such a page which forces
   * the navbar into a back position.
   */
  pageNested: boolean;

  /**
   * Which navigation profile icon should be rendered.
   *
   * This property is used to delegate the navbar right icon render.
   */
  pageActionIcon: UIActionIcon;

  /**
   * Which route the action icon should lead to.
   */
  pageActionRoute: string;

  /**
   * Defines the top navigation left action.
   */
  topNavigationLeftAction: TopNavigationLeftAction;

  /**
   * Defines the content mode of the top navigation bar.
   */
  topNavigationContentMode: TopNavigationContentMode;

  /**
   * The profile to be shown in the top navigation bar.
   */
  topNavigationProfile: TopNavigationProfile | null;

  /**
   * Defines the left menu style (wether it's a back arrow or a burger menu).
   */
  pageMenuMode: string;

  /**
   * Can be used to propagate back actions that need something else than pure navigation
   */
  customBackActionEvent: boolean;

  /**
   * To be used when we want a custom back route rather than the default router.go(-1)
   * e.g. when on a page using url query parameters-based inner navigation.
   */
  customBackRoute: string | null;
}
